<template lang="html">
  <div class="modal-wrapper choose-registration-modal">
    <div class="modal-close">
      <img @click="closeModal()" src="@/assets/icons/close.png" alt="close-modal-img">
    </div>
    <div class="modal-title">
      {{$t('main.userType')}}
    </div>
    <div class="big-btn-wrapper">
      <div @click="openModal('registerStandardModal')" class="big-btn red">
        <div class="big-btn-title">
          {{$t('main.registrationStandard')}}
        </div>
        <div class="big-btn-text">
          {{$t('main.registrationStandardText')}}
        </div>
        <div class="big-btn-continue">
          <span>{{$t('main.continue')}}</span>
          <img src="@/assets/icons/frontArrow.png" alt="forward arrow img">
        </div>
      </div>
      <div @click="openModal('registerBusinessModal')" class="big-btn yellow">
        <div class="big-btn-title">
          {{$t('main.registrationBusiness')}}
        </div>
        <div class="big-btn-text">
          {{$t('main.registrationBusinessText')}}
        </div>
        <div class="big-btn-continue">
          <span>{{$t('main.continue')}}</span>
          <img src="@/assets/icons/frontArrow.png" alt="forward arrow img">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import eventBus from '@/shared/eventBus.js'
export default {
  name: 'chooseRegistrationModal',
  methods: {
    openModal (modal) {
      eventBus.$emit('openModal', { component: modal, outsideClose: false })
    },
    closeModal () {
      eventBus.$emit('closeModal')
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/modalStyles.scss";

.modal-overlay .modal-wrapper.choose-registration-modal {
  width: auto;
  padding: 25px;
  padding-bottom: 59px;
  padding-top: 25px;

  .modal-title {
    padding-left: 20px;
    margin-bottom: 41px;
  }

  .big-btn-wrapper {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin: 0 20px;

    .big-btn {
      padding-left: 25px;
      padding-top: 27px;
      padding-right: 15px;
      padding-bottom: 13px;
      text-align: left;
      border-radius: 20px;
      cursor: pointer;
      transition-duration: 0.2s;
      // box-shadow: 0px 0px 0px rgba(112, 116, 223, 0.49);
      width: auto;
      max-width: calc(318px - 40px);
      height: auto;
      min-height: 160px;
      display: flex;
      flex-direction: column;

      .big-btn-title {
        font-style: normal;
        font-weight: 800;
        font-size: 18px;
        line-height: 29px;
        letter-spacing: 0.06em;
        margin-bottom: 10px;
        text-transform: uppercase;

        color: #FFFFFF;
      }
      .big-btn-text {
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        line-height: 21px;
        letter-spacing: 0.02em;
        color: rgba(255, 255, 255, 0.8);
      }
      .big-btn-continue {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        margin-top: auto;
        text-transform: uppercase;
      }
      .big-btn-continue span {
        margin-right: 10px;
        font-style: normal;
        font-weight: 800;
        font-size: 10px;
        line-height: 16px;
        letter-spacing: 0.06em;
      }
    }
    .big-btn:hover {
      box-shadow: 0px 6px 22px 2px rgba(208, 142, 121, 0.7);
      transform: scale(1.03);
    }
    .big-btn.red:hover {
      box-shadow: 0px 6px 22px 2px rgba(129, 77, 98, 0.4);
    }
    .big-btn:first-child {
      margin-right: 34px;
    }
    .big-btn.red {
      background-image: url("~@/assets/images/redBackground.png");
      background-size: cover;
      background-repeat: no-repeat;

      .big-btn-continue span {
        color: #F9D5D2;
      }
    }
    .big-btn.yellow {
      background-image: url("~@/assets/images/yellowBackground.png");
      background-size: cover;
      background-repeat: no-repeat;

      .big-btn-continue span {
        color: #FFD7BA;
      }
    }
  }
}
@media only screen and (max-width: 768px) {
  .modal-overlay .modal-wrapper.choose-registration-modal .big-btn-wrapper {
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .modal-overlay .modal-wrapper.choose-registration-modal .big-btn-wrapper .big-btn.red {
    margin-right: 0px;
    margin-bottom: 35px;
  }
}
</style>
